export const storageAlerts = {
	label: "Stock alerts",
	description: "Configure and manage your stock alerts to not miss any movement",
	search: "Search products",
	btnAddEmail: "Configure alert reception",
	btnAddProductAlert: "Add alert for a product",
	titleAlertPhone: "Get alerts on your phone!",
	descriptionAlertPhone: "Now you can register phone numbers to receive stock alerts",
	addEmailModal: {
		title: "Configure receiving email alerts",
		name: "Name",
		email: "Email",
		emptyText: "No registered emails",
		phone: "Phone",
		placeholders: {
			name: "Enter the name",
			email: "Enter the email",
			phone: "Enter the phone",
		},
	},
	addAlertModal: {
		title: "Add new alert",
		selectProduct: "Select the product",
		storageAlert: {
			label: "Alert",
			storageIn: "Stock in",
			below: "Below",
		},
		storageCritic: {
			label: "CRITICAL",
			storage: "Inventory",
			below: "Below",
		},
		add: "Create alert",
		invalidText:
			"The alert stock value cannot be less than or equal to the critical stock value",
	},
	columns: {
		product: "PRODUCT",
		storageQuantity: "CURRENT INVENTORY",
		storageAlert: {
			label: "ALERT",
			storageIn: "STOCK IN",
			from: "FROM",
		},
		storageCritic: {
			label: "CRITICAL",
			storage: "INVENTORY",
			from: "FROM",
		},
		actions: "ACTIONS",
	},
	filters: {
		ok: "OK",
		storageAlert: "Alert state",
		storageCritic: "Critical condition",
	},
};
